module.exports = __webpack_public_path__ + "static/media/pra-picture.34afc7f1.png";